import { useEffect,useRef,useState,useCallback } from "react";
import { useAppSelector } from "../../../Redux/hooks";
import { GraphQLFetchData } from "../utils/graghFetchData";
// import { setTypeSkin } from "../store/skinActions";
const PlayerCard = () => {
	const containerRef = useRef(null);
	const {GetLatestVideo} = GraphQLFetchData();
	const linkUrl = useAppSelector((state)=>state.skinReducer.link)
	const defaultSkin = useAppSelector((state)=>state.skinReducer.selectedSkinObject)
	const iframeRef = useRef(null)
	const editMode = useAppSelector((state) => state.skinReducer.editMode)
	const addSkin = useAppSelector((state)=>state.skinReducer.addSkin)
    const [iframeLoaded, setIframeLoaded] = useState(false);
	const showSkinCondition = useAppSelector((state)=>state.skinReducer.AddSkinContraints)

	useEffect(()=>{
		GetLatestVideo()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[])
	
	function handleIframeLoad() {
		let iframe = document.querySelector("#tesSkin");
		setIframeLoaded(true);
		iframe?.contentWindow?.postMessage({ info: 'skin', value: iframeLoaded }, '*');

	}
	
	const postSkinMessage = useCallback(() => {
		let iframe = document.querySelector("#tesSkin");
		iframe?.contentWindow?.postMessage({ info: 'SkinMessage', value: showSkinCondition.isAdd  ? addSkin: defaultSkin }, '*');
	}, 
	 // eslint-disable-next-line react-hooks/exhaustive-deps
	[defaultSkin]);

	useEffect(() => {
		postSkinMessage();
		// eslint-disable-next-line react-hooks/exhaustive-deps
}, [editMode, defaultSkin]);

	return (
		<div className="player-Card" ref={containerRef}>
						<iframe id='tesSkin'
						ref={iframeRef}
						title={linkUrl}
						width={'100%'}
						height={'100%'}
						allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen={true}
						src={`https:${linkUrl}`}
						onLoad={handleIframeLoad}

						></iframe>
			
				</div>
	);
};

export default PlayerCard;
